export default __webpack_public_path__ + "static/media/ditLoginLeftImage.a330628a.png";